import { getUploaderPathKey } from "@/store/features/bulkResize/utils/getSupportedExtensions";
import { FixedEditorLayout } from "components/modules/Layout/FixedEditorLayout/FixedEditorLayout";
import { EditorNavbar } from "components/modules/Navigation/EditorNavbar/EditorNavbar";
import { useRouter } from "next/router";
import { BottomMenu } from "./BottomMenu/BottomMenu";
import { BulkResizeSettings } from "./EditSettings/ResizeSettings/BulkResizeSettings";
import { Preview } from "./Preview/Preview";
import { useBulkResize } from "./useBulkResize";

export const BulkResizer = () => {
    const router = useRouter();
    useBulkResize();
    return (
        <FixedEditorLayout
            navbar={<EditorNavbar actionButton={null} url={`/${getUploaderPathKey(router.asPath)}/editor`} />}
            action={{ desktop: null }}
            bottomMenu={<BottomMenu />}
            controlBar={null}
            preview={<Preview />}
            leftBar={<BulkResizeSettings />}
        />
    );
};
